import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Timeslot } from 'src/app/models/Timeslot';

export interface NoInvoiceDialogData {
    projectTimeslots: Timeslot[];
    existingReason?: string;
    existingAttachmentUrl?: string;
}

@Component({
    selector: 'app-no-invoice-dialog',
    templateUrl: './no-invoice-dialog.component.html',
    styleUrls: ['./no-invoice-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class NoInvoiceDialogComponent {
    reason: string;
    attachment: File | null = null;
    isSubmitting = false;

    constructor(public dialogRef: MatDialogRef<NoInvoiceDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: NoInvoiceDialogData) {
        this.reason = data.existingReason || '';
    }

    get existingAttachmentUrl(): string | undefined {
        return this.data.existingAttachmentUrl;
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        this.attachment = input.files?.[0] ?? null;
    }

    canSubmit(): boolean {
        return (this.reason || '').trim().length > 0;
    }

    submit(): void {
        if (!this.canSubmit()) return;
        this.dialogRef.close({
            timeslots: this.data.projectTimeslots,
            reason: this.reason.trim(),
            attachment: this.attachment ?? undefined,
        });
    }

    cancel(): void {
        this.dialogRef.close(null);
    }
}
